import { render, staticRenderFns } from "./MinimalDocumentViewer.vue?vue&type=template&id=596dcf79&scoped=true&"
import script from "./MinimalDocumentViewer.vue?vue&type=script&lang=js&"
export * from "./MinimalDocumentViewer.vue?vue&type=script&lang=js&"
import style0 from "./MinimalDocumentViewer.vue?vue&type=style&index=0&id=596dcf79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596dcf79",
  null
  
)

export default component.exports